<template>
    <button
        :class="{
            'border-white text-white hover:border-accent-700 hover:bg-white hover:text-accent-700':
                appearance === 'white',
            'border-transparent bg-accent text-ash-200 hover:border-accent hover:bg-transparent hover:text-accent':
                appearance === 'accent',
            'border-transparent bg-white text-accent hover:bg-accent-400 hover:text-white':
                appearance === 'light',
        }"
        class="rounded-full border px-5 py-2.5 text-16/150 font-semibold transition-all duration-300">
        <slot />
    </button>
</template>

<script setup lang="ts">
defineProps({
    appearance: {
        type: String as PropType<'white' | 'accent' | 'light'>,
        default: 'white',
    },
})
</script>
